<template>
    <div class="container" style="margin-top: 10px;">
        <div class="row">
            <div class="col">
                <div class="alert alert-success" v-html="$t('views.booking.success.message')">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3>{{ $t('views.booking.common.titles.booking') }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <StaticPriceResult  
                    :startDate="new Date(request.startDate)"
                    :endDate="new Date(request.endDate)"
                    :adults="request.numberOfAdults"
                    :kids="request.numberOfKids"
                    :listing="listing"
                    :showListing="true">
                </StaticPriceResult>
            </div>
        </div>

        
        <hr class="solid">

        <div class="row">
            <div class="col-md-12">
                <h3>{{ $t('views.booking.common.titles.information') }}</h3>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-4">
                <h4>{{ $t('views.booking.common.titles.personal') }}</h4>
                <UnstyledList :entries="addressComponents"/>
            </div>
            <div class="col-12 col-md-4">
                <h4>{{ $t('views.booking.common.titles.contact') }}</h4>
                <UnstyledList :entries="contactComponents"></UnstyledList>
            </div>
            <div class="col-12 col-md-4">
                <h4>{{ $t('views.booking.common.titles.reservation') }}</h4>
                <UnstyledList :entries="reservationComponents"></UnstyledList>
            </div>
            <div class="col-12 col-md-4">
                <h4>{{ $t('views.booking.common.titles.reservation') }}</h4>
                <p>{{ request.message }} </p>
            </div>
        </div>

        <!-- <hr class="solid">

        <div class="row">
            <div class="col-md-12">
                <h3>{{ $t('views.booking.common.titles.nextSteps') }}</h3>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <p>{{ $t('views.booking.common.text.nextStepsExplanation') }}</p>
            </div>
        </div> -->
    </div>
</template>

<script>
import { viewMixin } from '@/mixins/viewMixin';
import { mapState } from 'vuex';
import StaticPriceResult from "@/components/level3/StaticPriceResult";
import UnstyledList from "@/components/common/UnstyledList";


export default {
    name: 'BookingSuccessView',
    mixins: [viewMixin],
    components: {
        StaticPriceResult,
        UnstyledList
    },
    computed: {
        listing: function() {
            return this.$store.getters.getCurrentListing;
        },
        addressComponents: function() {
            return [
                {
                    content: `${this.request.firstName} ${this.request.lastName }`
                },
                {
                    content: `${this.request.street} ${this.request.number }`
                },
                {
                    content: `${this.request.cap} ${this.request.city } (${ this.request.nation })`
                }
            ].filter(el => el.content.trim() !== '');
        },
        contactComponents: function() {
            return [
                {
                    icon: "fa-phone",
                    content: this.request.phoneNumber,
                },
                {
                    icon: "fa-mobile-alt",
                    content: this.request.mobileNumber,
                },
                {
                    icon: "fa-envelope",
                    content: this.request.email,
                }
            ].filter(el => el.content !== undefined);
        },
        reservationComponents: function() {
            return [
                {
                    icon: "fa-users",
                    content: this.request.numberOfAdults
                },
                {
                    icon: "fa-child",
                    content: this.request.numberOfKids
                },
                {
                    icon: "fa-calendar-alt",
                    content: `${this.$options.filters.dateFormat(this.request.startDate)} - ${this.$options.filters.dateFormat(this.request.endDate)}`
                }
            ].filter(el => el.content !== undefined);
        }
    },
    beforeDestroy() {
        // Reset the state
        // this.$store.commit('setBookingRequestConfirmation', undefined);
        // this.$store.commit('setBookingRequestListing', undefined);
    },
    created() {
        // Set the values here
        this.request = this.$store.getters.getBookingRequestConfirmation;
    },
    data() {
        return {
            request: undefined,
        }
    }
}
</script>

<style lang="scss" scoped>
    h3 {
        margin-bottom: 20px;
    }

    #offer {
        margin-bottom: 15px;
    }
</style>